import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@shared/datastore/core';
import { searchKeywordProjectsBackend } from './search-keyword-projects.backend';
import { transformSearchKeywordProjects } from './search-keyword-projects.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature(
      'searchKeywordProjects',
      transformSearchKeywordProjects,
    ),
    BackendModule.forFeature(
      'searchKeywordProjects',
      searchKeywordProjectsBackend,
    ),
  ],
})
export class DatastoreSearchKeywordProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-keyword-projects/search-keyword-projects.module.ts